import { ILanguage } from 'app/shared/model/language.model';

export interface IPrompt {
  id?: number | null;
  key?: string | null;
  value?: string | null;
  language?: ILanguage;
}

export const defaultValue: Readonly<IPrompt> = {};
